import { createStyles, Typography, withStyles } from '@material-ui/core';
import React from 'react';
import { TypographyAllProps } from 'globals/types';

const FsCaption = withStyles(() =>
  createStyles({
    root: {
      fontWeight: 700,
      textTransform: 'uppercase',
    },
  })
)((props: TypographyAllProps) => (
  <Typography variant="body2" component="span" {...props} />
));

export default FsCaption;
